import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { UPDATE_LANGUAGES_ASYNC } from 'containers/Settings/Languages/constants'

import {
  getLandingPagesError,
  getLandingPagesSuccess,
  updLandingPagesError,
  updLandingPagesSuccess,
} from './actions'
import { LANDING_FROM_REQUEST_ASYNC, LANDING_FROM_UPDATE_ASYNC } from './constants'

const getLandingPagesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      LANDING_FROM_REQUEST_ASYNC.INITIATE,
      LANDING_FROM_UPDATE_ASYNC.SUCCESS,
      UPDATE_LANGUAGES_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.impersonation)
      return true
    }),
    mergeMap(() =>
      api.settings.getSightsLandingPages(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getLandingPagesSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getLandingPagesError, error))),
        takeUntil(action$.pipe(ofType(LANDING_FROM_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updLandingPagesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(LANDING_FROM_UPDATE_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updateSightsLandingPages(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.settings.mailboxProtection.landings.data
        )
        .pipe(
          map((response) => updLandingPagesSuccess(response)),
          catchError((error) => of(epicsErrorHandler(updLandingPagesError, error))),
          takeUntil(action$.pipe(ofType(LANDING_FROM_UPDATE_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getLandingPagesEpic, updLandingPagesEpic)
